import Service from "../../../Services/index";

const CheckBag = {
    namespaced: true,
    state: {
        checkBagList : [],
        checkBagData : [],
        bag_data : [],
        check_bag_data :[],
        vendor_from_bag : [],
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        },
        form:{
            id:"",
            list : "",
            bag_name : "",
            date : "",
            vendor:"",
            pack_per_kg :"",
            quantity_per_kg :"",
            thickness_per_kg :""
        }
    },
    mutations: {
        GET_CHECKBAG_LIST: (state, res) => {
            state.checkBagList = res.data;
            state.dataPaginate = {
                current_page :res.current_page,
                    from : res.from,
                    last_page : res.last_page,
                    per_page : res.per_page,
                    total : res.total,
                    to : res.to
            }
        },
        GET_CHECKBAG_BY_ID: (state, res) => {
            state.form = res;
        },
        GET_BAG_DATA_ALL:(state,res)=>{
            state.bag_data = res;
        },
        GET_VENDOR_FROM_BAG:(state,res)=>{
            state.vendor_from_bag = res
        },
        CLEAR_FORM_DATA:(state)=>{
            state.form = {
                id:"",
                list : "",
                bag_name : "",
                date : "",
                vendor:"",
                pack_per_kg :"",
                quantity_per_kg :"",
                thickness_per_kg :""
            }
        }
    },
    actions: {
        setCheckedBag({ commit },page=1) {
            return Service.CheckBag.getCheckBag(page).then(response => {
                commit("GET_CHECKBAG_LIST", response);
            });
        },
        getCheckBagFromType({commit},{page=1,type_id}){
            return Service.CheckBag.getCheckBagByType(page,type_id).then(response => {
                commit("GET_CHECKBAG_LIST", response);
            });
        },
        save({commit},{id,data}) {
            if(!id){
                return Service.CheckBag.createCheckBag(data);
            }else{
                return Service.CheckBag.updateCheckBag(id,data);
            }
        },
        show({commit},id){
            return Service.CheckBag.showCheckBag(id).then(response=>{
                console.log(response);
                commit("GET_CHECKBAG_BY_ID",response)
            })
        },
        delete({commit},id){
            console.log(id);
            return Service.CheckBag.deleteCheckBag(id);
        },
        getBagData({commit}){
            return Service.CheckBag.getBagData().then(response=>{
                commit("GET_BAG_DATA_ALL",response)
            })
        },
        getVendorFromVendor({commit},data){
            return Service.CheckBag.getVendorFromBag(data).then(response=>{
                commit("GET_VENDOR_FROM_BAG",response);
            });
        },
        clearData({commit}){
            commit("CLEAR_FORM_DATA");
        },
        search({commit},data){
            return Service.BagData.searchBagData(data).then(response=>{
                commit("GET_CHECKBAG_LIST", response);
            })
        }

    }
};

export default CheckBag;
